export const pharmcyOptions = [
    // { id: 1, label: "PharmaForce Rx (10-0754)" },
    // { id: 2, label: "PharmaForce Rx (10-0864)" },
    // { id: 3, label: "PharmaForce Rx (10-1024)" },
    // { id: 4, label: "PharmaForce Rx (10-0372)" },
    { id: 264, label: "PharmaForce Rx #2565" },
    { id: 92, label: "PharmaForce Rx #0754" },
    { id: 99, label: "PharmaForce Rx #0864" },
    { id: 118, label: "PharmaForce Rx #1024" },
    { id: 45, label: "PharmaForce Rx #0372" },
    { id: 2, label: "PharmaForce Rx ##3060" },
    { id: 3, label: "PharmaForce Rx #0003" },
    { id: 4, label: "PharmaForce Rx #0025" },
    { id: 5, label: "PharmaForce Rx #0029" },
    { id: 6, label: "PharmaForce Rx #0040" },
    { id: 7, label: "PharmaForce Rx #0051" },
    { id: 8, label: "PharmaForce Rx #0080" },
    { id: 9, label: "PharmaForce Rx #0089" },
    { id: 10, label: "PharmaForce Rx #0114" },
    { id: 11, label: "PharmaForce Rx #0115" },
    { id: 12, label: "PharmaForce Rx #0118" },
    { id: 13, label: "PharmaForce Rx #0121" },
    { id: 14, label: "PharmaForce Rx #0153" },
    { id: 15, label: "PharmaForce Rx #0159" },
    { id: 16, label: "PharmaForce Rx #0164" },
    { id: 17, label: "PharmaForce Rx #0164" },
    { id: 18, label: "PharmaForce Rx #0176" },
    { id: 19, label: "PharmaForce Rx #0176" },
    { id: 20, label: "PharmaForce Rx #0178" },
    { id: 21, label: "PharmaForce Rx #0182" },
    { id: 22, label: "PharmaForce Rx #0186" },
    { id: 23, label: "PharmaForce Rx #0203" },
    { id: 24, label: "PharmaForce Rx #0205" },
    { id: 25, label: "PharmaForce Rx #0210" },
    { id: 26, label: "PharmaForce Rx #0218" },
    { id: 27, label: "PharmaForce Rx #0219" },
    { id: 28, label: "PharmaForce Rx #0222" },
    { id: 29, label: "PharmaForce Rx #0247" },
    { id: 30, label: "PharmaForce Rx #0252" },
    { id: 31, label: "PharmaForce Rx #0252" },
    { id: 32, label: "PharmaForce Rx #0258" },
    { id: 33, label: "PharmaForce Rx #0258" },
    { id: 34, label: "PharmaForce Rx #0262" },
    { id: 35, label: "PharmaForce Rx #0264" },
    { id: 36, label: "PharmaForce Rx #0268" },
    { id: 37, label: "PharmaForce Rx #0269" },
    { id: 38, label: "PharmaForce Rx #0269" },
    { id: 39, label: "PharmaForce Rx #0273" },
    { id: 40, label: "PharmaForce Rx #0276" },
    { id: 41, label: "PharmaForce Rx #0305" },
    { id: 42, label: "PharmaForce Rx #0341" },
    { id: 43, label: "PharmaForce Rx #0357" },
    { id: 44, label: "PharmaForce Rx #0363" },
    { id: 46, label: "PharmaForce Rx #0377" },
    { id: 47, label: "PharmaForce Rx #0378" },
    { id: 48, label: "PharmaForce Rx #0391" },
    { id: 49, label: "PharmaForce Rx #0391" },
    { id: 50, label: "PharmaForce Rx #0411" },
    { id: 51, label: "PharmaForce Rx #0411" },
    { id: 52, label: "PharmaForce Rx #0419" },
    { id: 53, label: "PharmaForce Rx #0425" },
    { id: 54, label: "PharmaForce Rx #0451" },
    { id: 55, label: "PharmaForce Rx #0495" },
    { id: 56, label: "PharmaForce Rx #0501" },
    { id: 57, label: "PharmaForce Rx #0510" },
    { id: 58, label: "PharmaForce Rx #0511" },
    { id: 59, label: "PharmaForce Rx #0514" },
    { id: 60, label: "PharmaForce Rx #0515Wal" },
    { id: 61, label: "PharmaForce Rx #0520" },
    { id: 62, label: "PharmaForce Rx #0557" },
    { id: 63, label: "PharmaForce Rx #0574" },
    { id: 64, label: "PharmaForce Rx #0578" },
    { id: 65, label: "PharmaForce Rx #0583" },
    { id: 66, label: "PharmaForce Rx #0586" },
    { id: 67, label: "PharmaForce Rx #0599" },
    { id: 68, label: "PharmaForce Rx #0616" },
    { id: 69, label: "PharmaForce Rx #0619" },
    { id: 70, label: "PharmaForce Rx #0619" },
    { id: 71, label: "PharmaForce Rx #0620" },
    { id: 72, label: "PharmaForce Rx #0621" },
    { id: 73, label: "PharmaForce Rx #0625" },
    { id: 74, label: "PharmaForce Rx #0627" },
    { id: 75, label: "PharmaForce Rx #0630" },
    { id: 76, label: "PharmaForce Rx #0634" },
    { id: 77, label: "PharmaForce Rx #0639" },
    { id: 78, label: "PharmaForce Rx #0642" },
    { id: 79, label: "PharmaForce Rx #0663" },
    { id: 80, label: "PharmaForce Rx #0674" },
    { id: 81, label: "PharmaForce Rx #0678" },
    { id: 82, label: "PharmaForce Rx #0680" },
    { id: 83, label: "PharmaForce Rx #0684" },
    { id: 84, label: "PharmaForce Rx #0685" },
    { id: 85, label: "PharmaForce Rx #0690" },
    { id: 86, label: "PharmaForce Rx #0698" },
    { id: 87, label: "PharmaForce Rx #0708" },
    { id: 88, label: "PharmaForce Rx #0708" },
    { id: 89, label: "PharmaForce Rx #0724" },
    { id: 90, label: "PharmaForce Rx #0739" },
    { id: 91, label: "PharmaForce Rx #0742" },
    { id: 93, label: "PharmaForce Rx #0780" },
    { id: 94, label: "PharmaForce Rx #0783" },
    { id: 95, label: "PharmaForce Rx #0785" },
    { id: 96, label: "PharmaForce Rx #0814" },
    { id: 97, label: "PharmaForce Rx #0820" },
    { id: 98, label: "PharmaForce Rx #0834" },
    { id: 100, label: "PharmaForce Rx #0875" },
    { id: 101, label: "PharmaForce Rx #0879" },
    { id: 102, label: "PharmaForce Rx #0887" },
    { id: 103, label: "PharmaForce Rx #0891" },
    { id: 104, label: "PharmaForce Rx #0903" },
    { id: 105, label: "PharmaForce Rx #0916" },
    { id: 106, label: "PharmaForce Rx #0922" },
    { id: 107, label: "PharmaForce Rx #0929" },
    { id: 108, label: "PharmaForce Rx #0973" },
    { id: 109, label: "PharmaForce Rx #0995" },
    { id: 110, label: "PharmaForce Rx #0998" },
    { id: 111, label: "PharmaForce Rx #10-1142" },
    { id: 112, label: "PharmaForce Rx #10-1149" },
    { id: 113, label: "PharmaForce Rx #10-1334" },
    { id: 114, label: "PharmaForce Rx #1014" },
    { id: 115, label: "PharmaForce Rx #1017" },
    { id: 116, label: "PharmaForce Rx #10-1778" },
    { id: 117, label: "PharmaForce Rx #1023" },
    { id: 119, label: "PharmaForce Rx #1025" },
    { id: 120, label: "PharmaForce Rx #1038" },
    { id: 121, label: "PharmaForce Rx #10-3847" },
    { id: 122, label: "PharmaForce Rx #10-4474" },
    { id: 123, label: "PharmaForce Rx #10-5315" },
    { id: 124, label: "PharmaForce Rx #1059" },
    { id: 125, label: "PharmaForce Rx #1069" },
    { id: 126, label: "PharmaForce Rx #1087" },
    { id: 127, label: "PharmaForce Rx #1088" },
    { id: 128, label: "PharmaForce Rx #1111" },
    { id: 129, label: "PharmaForce Rx #1115" },
    { id: 130, label: "PharmaForce Rx #1116" },
    { id: 131, label: "PharmaForce Rx #1122" },
    { id: 132, label: "PharmaForce Rx #1135" },
    { id: 133, label: "PharmaForce Rx #1139" },
    { id: 134, label: "PharmaForce Rx #1140" },
    { id: 135, label: "PharmaForce Rx #1146" },
    { id: 136, label: "PharmaForce Rx #1149" },
    { id: 137, label: "PharmaForce Rx #1155" },
    { id: 138, label: "PharmaForce Rx #1167" },
    { id: 139, label: "PharmaForce Rx #1174" },
    { id: 140, label: "PharmaForce Rx #1174" },
    { id: 141, label: "PharmaForce Rx #119" },
    { id: 142, label: "PharmaForce Rx #1192" },
    { id: 143, label: "PharmaForce Rx #1233" },
    { id: 144, label: "PharmaForce Rx #1243" },
    { id: 145, label: "PharmaForce Rx #1260" },
    { id: 146, label: "PharmaForce Rx #1302" },
    { id: 147, label: "PharmaForce Rx #1334" },
    { id: 148, label: "PharmaForce Rx #1345" },
    { id: 149, label: "PharmaForce Rx #1351" },
    { id: 150, label: "PharmaForce Rx #1360" },
    { id: 151, label: "PharmaForce Rx #1403" },
    { id: 152, label: "PharmaForce Rx #1416" },
    { id: 153, label: "PharmaForce Rx #1423" },
    { id: 154, label: "PharmaForce Rx #1424" },
    { id: 155, label: "PharmaForce Rx #1427" },
    { id: 156, label: "PharmaForce Rx #1442" },
    { id: 157, label: "PharmaForce Rx #1445" },
    { id: 158, label: "PharmaForce Rx #1448" },
    { id: 159, label: "PharmaForce Rx #1450" },
    { id: 160, label: "PharmaForce Rx #1457" },
    { id: 161, label: "PharmaForce Rx #1459" },
    { id: 162, label: "PharmaForce Rx #1462" },
    { id: 163, label: "PharmaForce Rx #1465" },
    { id: 164, label: "PharmaForce Rx #1473" },
    { id: 165, label: "PharmaForce Rx #1477" },
    { id: 166, label: "PharmaForce Rx #1477" },
    { id: 167, label: "PharmaForce Rx #1478" },
    { id: 168, label: "PharmaForce Rx #1499" },
    { id: 169, label: "PharmaForce Rx #1499" },
    { id: 170, label: "PharmaForce Rx #1505" },
    { id: 171, label: "PharmaForce Rx #1539" },
    { id: 172, label: "PharmaForce Rx #1544" },
    { id: 173, label: "PharmaForce Rx #1555" },
    { id: 174, label: "PharmaForce Rx #157" },
    { id: 175, label: "PharmaForce Rx #1580" },
    { id: 176, label: "PharmaForce Rx #1594" },
    { id: 177, label: "PharmaForce Rx #1595" },
    { id: 178, label: "PharmaForce Rx #1616" },
    { id: 179, label: "PharmaForce Rx #1617" },
    { id: 180, label: "PharmaForce Rx #1628" },
    { id: 181, label: "PharmaForce Rx #1630" },
    { id: 182, label: "PharmaForce Rx #1645" },
    { id: 183, label: "PharmaForce Rx #1652" },
    { id: 184, label: "PharmaForce Rx #1653" },
    { id: 185, label: "PharmaForce Rx #1684" },
    { id: 186, label: "PharmaForce Rx #1700" },
    { id: 187, label: "PharmaForce Rx #1701" },
    { id: 188, label: "PharmaForce Rx #1703" },
    { id: 189, label: "PharmaForce Rx #1710" },
    { id: 190, label: "PharmaForce Rx #1733" },
    { id: 191, label: "PharmaForce Rx #1736" },
    { id: 192, label: "PharmaForce Rx #1742" },
    { id: 193, label: "PharmaForce Rx #1763" },
    { id: 194, label: "PharmaForce Rx #1772" },
    { id: 195, label: "PharmaForce Rx #18" },
    { id: 196, label: "PharmaForce Rx #1807" },
    { id: 197, label: "PharmaForce Rx #1815" },
    { id: 198, label: "PharmaForce Rx #1829" },
    { id: 199, label: "PharmaForce Rx #1839" },
    { id: 200, label: "PharmaForce Rx #1859" },
    { id: 201, label: "PharmaForce Rx #1860" },
    { id: 202, label: "PharmaForce Rx #1869" },
    { id: 203, label: "PharmaForce Rx #1875" },
    { id: 204, label: "PharmaForce Rx #1882" },
    { id: 205, label: "PharmaForce Rx #1887" },
    { id: 206, label: "PharmaForce Rx #1889" },
    { id: 207, label: "PharmaForce Rx #1890" },
    { id: 208, label: "PharmaForce Rx #1891" },
    { id: 209, label: "PharmaForce Rx #1904" },
    { id: 210, label: "PharmaForce Rx #1919" },
    { id: 211, label: "PharmaForce Rx #1932" },
    { id: 212, label: "PharmaForce Rx #1934" },
    { id: 213, label: "PharmaForce Rx #1934" },
    { id: 214, label: "PharmaForce Rx #1935" },
    { id: 215, label: "PharmaForce Rx #1936" },
    { id: 216, label: "PharmaForce Rx #1940" },
    { id: 217, label: "PharmaForce Rx #1968" },
    { id: 218, label: "PharmaForce Rx #1986" },
    { id: 219, label: "PharmaForce Rx #1991" },
    { id: 220, label: "PharmaForce Rx #2001" },
    { id: 221, label: "PharmaForce Rx #2007" },
    { id: 222, label: "PharmaForce Rx #2038" },
    { id: 223, label: "PharmaForce Rx #2040" },
    { id: 224, label: "PharmaForce Rx #2068" },
    { id: 225, label: "PharmaForce Rx #2073" },
    { id: 226, label: "PharmaForce Rx #2075" },
    { id: 227, label: "PharmaForce Rx #2098" },
    { id: 228, label: "PharmaForce Rx #2100" },
    { id: 229, label: "PharmaForce Rx #2108" },
    { id: 230, label: "PharmaForce Rx #2109" },
    { id: 231, label: "PharmaForce Rx #2141" },
    { id: 232, label: "PharmaForce Rx #2150" },
    { id: 233, label: "PharmaForce Rx #2152" },
    { id: 234, label: "PharmaForce Rx #2163" },
    { id: 235, label: "PharmaForce Rx #2194" },
    { id: 236, label: "PharmaForce Rx #2243" },
    { id: 237, label: "PharmaForce Rx #2244" },
    { id: 238, label: "PharmaForce Rx #2248" },
    { id: 239, label: "PharmaForce Rx #2254" },
    { id: 240, label: "PharmaForce Rx #2258" },
    { id: 241, label: "PharmaForce Rx #2275" },
    { id: 242, label: "PharmaForce Rx #2277" },
    { id: 243, label: "PharmaForce Rx #2279" },
    { id: 244, label: "PharmaForce Rx #231" },
    { id: 245, label: "PharmaForce Rx #2337" },
    { id: 246, label: "PharmaForce Rx #2358" },
    { id: 247, label: "PharmaForce Rx #2370" },
    { id: 248, label: "PharmaForce Rx #2417" },
    { id: 249, label: "PharmaForce Rx #2429" },
    { id: 250, label: "PharmaForce Rx #2431" },
    { id: 251, label: "PharmaForce Rx #2441" },
    { id: 252, label: "PharmaForce Rx #2445" },
    { id: 253, label: "PharmaForce Rx #2473" },
    { id: 254, label: "PharmaForce Rx #2474" },
    { id: 255, label: "PharmaForce Rx #2484" },
    { id: 256, label: "PharmaForce Rx #2490" },
    { id: 257, label: "PharmaForce Rx #2495" },
    { id: 258, label: "PharmaForce Rx #2508" },
    { id: 259, label: "PharmaForce Rx #2514" },
    { id: 260, label: "PharmaForce Rx #2535" },
    { id: 261, label: "PharmaForce Rx #2548" },
    { id: 262, label: "PharmaForce Rx #2548" },
    { id: 263, label: "PharmaForce Rx #2555" },
    { id: 265, label: "PharmaForce Rx #2566" },
    { id: 266, label: "PharmaForce Rx #2576" },
    { id: 267, label: "PharmaForce Rx #2585" },
    { id: 268, label: "PharmaForce Rx #2587" },
    { id: 269, label: "PharmaForce Rx #2595" },
    { id: 270, label: "PharmaForce Rx #2610" },
    { id: 271, label: "PharmaForce Rx #2613" },
    { id: 272, label: "PharmaForce Rx #2630" },
    { id: 273, label: "PharmaForce Rx #2645" },
    { id: 274, label: "PharmaForce Rx #2646" },
    { id: 275, label: "PharmaForce Rx #2650" },
    { id: 276, label: "PharmaForce Rx #2666" },
    { id: 277, label: "PharmaForce Rx #2672" },
    { id: 278, label: "PharmaForce Rx #2689" },
    { id: 279, label: "PharmaForce Rx #2696" },
    { id: 280, label: "PharmaForce Rx #2703" },
    { id: 281, label: "PharmaForce Rx #2711" },
    { id: 282, label: "PharmaForce Rx #2715" },
    { id: 283, label: "PharmaForce Rx #2717" },
    { id: 284, label: "PharmaForce Rx #2720" },
    { id: 285, label: "PharmaForce Rx #2753" },
    { id: 286, label: "PharmaForce Rx #2760" },
    { id: 287, label: "PharmaForce Rx #2760" },
    { id: 288, label: "PharmaForce Rx #2761" },
    { id: 289, label: "PharmaForce Rx #2762" },
    { id: 290, label: "PharmaForce Rx #2780" },
    { id: 291, label: "PharmaForce Rx #2781" },
    { id: 292, label: "PharmaForce Rx #2792" },
    { id: 293, label: "PharmaForce Rx #2809" },
    { id: 294, label: "PharmaForce Rx #281" },
    { id: 295, label: "PharmaForce Rx #2810" },
    { id: 296, label: "PharmaForce Rx #2811" },
    { id: 297, label: "PharmaForce Rx #2811" },
    { id: 298, label: "PharmaForce Rx #2823" },
    { id: 299, label: "PharmaForce Rx #2833" },
    { id: 300, label: "PharmaForce Rx #2840" },
    { id: 301, label: "PharmaForce Rx #2841" },
    { id: 302, label: "PharmaForce Rx #2846" },
    { id: 303, label: "PharmaForce Rx #2861" },
    { id: 304, label: "PharmaForce Rx #2870" },
    { id: 305, label: "PharmaForce Rx #2871" },
    { id: 306, label: "PharmaForce Rx #2893" },
    { id: 307, label: "PharmaForce Rx #2894" },
    { id: 308, label: "PharmaForce Rx #2900" },
    { id: 309, label: "PharmaForce Rx #2931" },
    { id: 310, label: "PharmaForce Rx #2933" },
    { id: 311, label: "PharmaForce Rx #2968" },
    { id: 312, label: "PharmaForce Rx #2984" },
    { id: 313, label: "PharmaForce Rx #2985" },
    { id: 314, label: "PharmaForce Rx #3059" },
    { id: 315, label: "PharmaForce Rx #3060" },
    { id: 316, label: "PharmaForce Rx #3101" },
    { id: 317, label: "PharmaForce Rx #3133" },
    { id: 318, label: "PharmaForce Rx #3149" },
    { id: 319, label: "PharmaForce Rx #3234" },
    { id: 320, label: "PharmaForce Rx #3251" },
    { id: 321, label: "PharmaForce Rx #3260" },
    { id: 322, label: "PharmaForce Rx #3282" },
    { id: 323, label: "PharmaForce Rx #3303" },
    { id: 324, label: "PharmaForce Rx #3337" },
    { id: 325, label: "PharmaForce Rx #3339" },
    { id: 326, label: "PharmaForce Rx #3344" },
    { id: 327, label: "PharmaForce Rx #3422" },
    { id: 328, label: "PharmaForce Rx #3435" },
    { id: 329, label: "PharmaForce Rx #3447" },
    { id: 330, label: "PharmaForce Rx #3478" },
    { id: 331, label: "PharmaForce Rx #3480" },
    { id: 332, label: "PharmaForce Rx #3489" },
    { id: 333, label: "PharmaForce Rx #3502" },
    { id: 334, label: "PharmaForce Rx #3522" },
    { id: 335, label: "PharmaForce Rx #3528" },
    { id: 336, label: "PharmaForce Rx #3541" },
    { id: 337, label: "PharmaForce Rx #3564" },
    { id: 338, label: "PharmaForce Rx #3571" },
    { id: 339, label: "PharmaForce Rx #3583" },
    { id: 340, label: "PharmaForce Rx #3638" },
    { id: 341, label: "PharmaForce Rx #3639" },
    { id: 342, label: "PharmaForce Rx #3641" },
    { id: 343, label: "PharmaForce Rx #3720" },
    { id: 344, label: "PharmaForce Rx #3723" },
    { id: 345, label: "PharmaForce Rx #3724" },
    { id: 346, label: "PharmaForce Rx #3739" },
    { id: 347, label: "PharmaForce Rx #3770" },
    { id: 348, label: "PharmaForce Rx #3772" },
    { id: 349, label: "PharmaForce Rx #3774" },
    { id: 350, label: "PharmaForce Rx #3778" },
    { id: 351, label: "PharmaForce Rx #3781" },
    { id: 352, label: "PharmaForce Rx #3784" },
    { id: 353, label: "PharmaForce Rx #3801" },
    { id: 354, label: "PharmaForce Rx #3802" },
    { id: 355, label: "PharmaForce Rx #3847" },
    { id: 356, label: "PharmaForce Rx #3852" },
    { id: 357, label: "PharmaForce Rx #3990" },
    { id: 358, label: "PharmaForce Rx #4054" },
    { id: 359, label: "PharmaForce Rx #4168" },
    { id: 360, label: "PharmaForce Rx #4226" },
    { id: 361, label: "PharmaForce Rx #4238" },
    { id: 362, label: "PharmaForce Rx #4277" },
    { id: 363, label: "PharmaForce Rx #4372" },
    { id: 364, label: "PharmaForce Rx #4394" },
    { id: 365, label: "PharmaForce Rx #4417" },
    { id: 366, label: "PharmaForce Rx #4420" },
    { id: 367, label: "PharmaForce Rx #4423" },
    { id: 368, label: "PharmaForce Rx #4456" },
    { id: 369, label: "PharmaForce Rx #4457" },
    { id: 370, label: "PharmaForce Rx #4461" },
    { id: 371, label: "PharmaForce Rx #4487" },
    { id: 372, label: "PharmaForce Rx #4514" },
    { id: 373, label: "PharmaForce Rx #4519" },
    { id: 374, label: "PharmaForce Rx #4525" },
    { id: 375, label: "PharmaForce Rx #4586" },
    { id: 376, label: "PharmaForce Rx #4616" },
    { id: 377, label: "PharmaForce Rx #4619" },
    { id: 378, label: "PharmaForce Rx #4619" },
    { id: 379, label: "PharmaForce Rx #4636" },
    { id: 380, label: "PharmaForce Rx #4697" },
    { id: 381, label: "PharmaForce Rx #501" },
    { id: 382, label: "PharmaForce Rx #5023" },
    { id: 383, label: "PharmaForce Rx #5039" },
    { id: 384, label: "PharmaForce Rx #5047" },
    { id: 385, label: "PharmaForce Rx #5071" },
    { id: 386, label: "PharmaForce Rx #5071" },
    { id: 387, label: "PharmaForce Rx #5076" },
    { id: 388, label: "PharmaForce Rx #5095" },
    { id: 389, label: "PharmaForce Rx #5103" },
    { id: 390, label: "PharmaForce Rx #5130" },
    { id: 391, label: "PharmaForce Rx #5185" },
    { id: 392, label: "PharmaForce Rx #5203" },
    { id: 393, label: "PharmaForce Rx #5229" },
    { id: 394, label: "PharmaForce Rx #5263" },
    { id: 395, label: "PharmaForce Rx #5274" },
    { id: 396, label: "PharmaForce Rx #5296" },
    { id: 397, label: "PharmaForce Rx #5309" },
    { id: 398, label: "PharmaForce Rx #5315" },
    { id: 399, label: "PharmaForce Rx #5315" },
    { id: 400, label: "PharmaForce Rx #5315/Termed 11/1/2020" },
    { id: 401, label: "PharmaForce Rx #5319" },
    { id: 402, label: "PharmaForce Rx #5335" },
    { id: 403, label: "PharmaForce Rx #5340" },
    { id: 404, label: "PharmaForce Rx #5376" },
    { id: 405, label: "PharmaForce Rx #5383" },
    { id: 406, label: "PharmaForce Rx #5384" },
    { id: 407, label: "PharmaForce Rx #5394" },
    { id: 408, label: "PharmaForce Rx #5408" },
    { id: 409, label: "PharmaForce Rx #5422" },
    { id: 410, label: "PharmaForce Rx #5436" },
    { id: 411, label: "PharmaForce Rx #5441" },
    { id: 412, label: "PharmaForce Rx #5443" },
    { id: 413, label: "PharmaForce Rx #5450" },
    { id: 414, label: "PharmaForce Rx #5459" },
    { id: 415, label: "PharmaForce Rx #5471" },
    { id: 416, label: "PharmaForce Rx #5476" },
    { id: 417, label: "PharmaForce Rx #5477" },
    { id: 418, label: "PharmaForce Rx #5495" },
    { id: 419, label: "PharmaForce Rx #5632" },
    { id: 420, label: "PharmaForce Rx #5633" },
    { id: 421, label: "PharmaForce Rx #5701" },
    { id: 422, label: "PharmaForce Rx #5753" },
    { id: 423, label: "PharmaForce Rx #5804" },
    { id: 424, label: "PharmaForce Rx #5829" },
    { id: 425, label: "PharmaForce Rx #5881" },
    { id: 426, label: "PharmaForce Rx #5891" },
    { id: 427, label: "PharmaForce Rx #5908" },
    { id: 428, label: "PharmaForce Rx #5944" },
    { id: 429, label: "PharmaForce Rx #6172" },
    { id: 430, label: "PharmaForce Rx #6190" },
    { id: 431, label: "PharmaForce Rx #6951" },
    { id: 432, label: "PharmaForce Rx #6952" },
    { id: 433, label: "PharmaForce Rx #696" },
    { id: 434, label: "PharmaForce Rx #7188" },
    { id: 435, label: "PharmaForce Rx #7217" },
    { id: 436, label: "PharmaForce Rx #785" },
    { id: 437, label: "PharmaForce Rx #81" },
    { id: 438, label: "PharmaForce Rx #887" },
    { id: 439, label: "PharmaForce Rx 0862" },
    { id: 440, label: "PharmaForce Rx 10-0005" },
    { id: 441, label: "PharmaForce Rx 10-0018" },
    { id: 442, label: "PharmaForce Rx 10-0024" },
    { id: 443, label: "PharmaForce Rx 10-0045" },
    { id: 444, label: "PharmaForce Rx 10-0054" },
    { id: 445, label: "PharmaForce Rx 10-0057" },
    { id: 446, label: "PharmaForce Rx 10-0068" },
    { id: 447, label: "PharmaForce Rx 10-0091" },
    { id: 448, label: "PharmaForce Rx 10-0102" },
    { id: 449, label: "PharmaForce Rx 10-0119" },
    { id: 450, label: "PharmaForce Rx 10-0128" },
    { id: 451, label: "PharmaForce Rx 10-0144" },
    { id: 452, label: "PharmaForce Rx 10-0157" },
    { id: 453, label: "PharmaForce Rx 10-0160" },
    { id: 454, label: "PharmaForce Rx 10-0164" },
    { id: 455, label: "PharmaForce Rx 10-0169" },
    { id: 456, label: "PharmaForce Rx 10-0229" },
    { id: 457, label: "PharmaForce Rx 10-0281" },
    { id: 458, label: "PharmaForce Rx 10-0410" },
    { id: 459, label: "PharmaForce Rx 10-0431" },
    { id: 460, label: "PharmaForce Rx 10-0491" },
    { id: 461, label: "PharmaForce Rx 10-2431" },
    { id: 462, label: "PharmaForce Rx 10-2575" },
    { id: 463, label: "PharmaForce Rx 10-2587" },
    { id: 464, label: "PharmaForce Rx 10-4108" },
    { id: 465, label: "PharmaForce Rx 10-4168" },
    { id: 466, label: "PharmaForce Rx 10-4375" },
    { id: 467, label: "PharmaForce Rx 10-4460" },
    { id: 468, label: "PharmaForce Rx 10-4516" },
    { id: 469, label: "PharmaForce Rx 10-6876" },
    { id: 470, label: "PharmaForce Rx 10-6943" },
    { id: 471, label: "PharmaForce Rx 10-7242" },
    { id: 472, label: "PharmaForce Rx 131" },
    { id: 473, label: "PharmaForce Rx 3543" },
    { id: 474, label: "PharmaForce Rx 36" },
    { id: 475, label: "PharmaForce Rx 5780" },
    { id: 476, label: "PharmaForce Rx #05890" },
    { id: 477, label: "PharmaForce Rx #10-00155(MH)" },
    { id: 478, label: "PharmaForce Rx #10-00707(MH)" },
    { id: 479, label: "PharmaForce Rx #10-01468(MH)" },
    { id: 480, label: "PharmaForce Rx #10-1345" },
    { id: 481, label: "PharmaForce Rx #10-1424" },
    { id: 482, label: "PharmaForce Rx #10-1486" },
    { id: 483, label: "PharmaForce Rx #10-1525" },
    { id: 484, label: "PharmaForce Rx #10-1730" },
    { id: 485, label: "PharmaForce Rx #10-1833" },
    { id: 486, label: "PharmaForce Rx #10-1934" },
    { id: 487, label: "PharmaForce Rx #10-2160" },
    { id: 488, label: "PharmaForce Rx #10-2645" },
    { id: 489, label: "PharmaForce Rx #10-2795" },
    { id: 490, label: "PharmaForce Rx #10-4636" },
    { id: 491, label: "PharmaForce Rx #10-4682" },
    { id: 492, label: "PharmaForce Rx #10-5343" },
    { id: 493, label: "PharmaForce Rx #10-5779" },
    { id: 494, label: "PharmaForce Rx #2278" },
    { id: 495, label: "PharmaForce Rx #2561" },
    { id: 496, label: "PharmaForce Rx #5445" },
    { id: 497, label: "PharmaForce Rx 10-0014" },
    { id: 498, label: "PharmaForce Rx 1009" },
    { id: 499, label: "PharmaForce Rx 1335" },
    { id: 500, label: "PharmaForce Rx 138" },
    { id: 501, label: "PharmaForce Rx 179" },
    { id: 502, label: "PharmaForce Rx 2178" },
    { id: 503, label: "PharmaForce Rx 2221" },
    { id: 504, label: "PharmaForce Rx 2702" },
    { id: 505, label: "PharmaForce Rx 2839" },
    { id: 506, label: "PharmaForce Rx 3062" },
    { id: 507, label: "PharmaForce Rx 3238" },
    { id: 508, label: "PharmaForce Rx 379" },
    { id: 509, label: "PharmaForce Rx 4381" },
    { id: 510, label: "PharmaForce Rx 444" },
    { id: 511, label: "PharmaForce Rx 5315" },
    { id: 512, label: "PharmaForce Rx 5692" },
    { id: 513, label: "PharmaForce Rx 5693" },
    { id: 514, label: "PharmaForce Rx 78" },
    { id: 515, label: "PharmaForce Rx 86" },
    { id: 516, label: "PharmaForce Rx 92" },
    { id: 517, label: "PharmaForce Rx #0112" },
    { id: 518, label: "PharmaForce Rx #0118" },

];

export const coveredEntityOptions = [
    // { id: 1, label: "PharmaForce Entity" },
    // { id: 2, label: "Blue Ridge Medical Center" },
    // { id: 3, label:"Candler County Hospital"},
    { id: 19, label: "Covered Entity #1" },
    { id: 24, label: "Covered Entity #1" },
    { id: 2, label: "3RD STREET COMMUNITY CLINIC(CH057110)" },
    { id: 3, label: "AARON E. HENRY COMMUNITY HEALTH SERVICES CENTER, INC(CH046150)" },
    { id: 4, label: "Access Family Health(CH046860)" },
    { id: 5, label: "ACI Client - Edwards County Hospital(CAH171317-00)" },
    { id: 6, label: "ACI Client - Share Medical Center(CAH371341)" },
    { id: 7, label: "ACI client- Lincoln County Public Hospital District No. 3(CAH501305-00)" },
    { id: 8, label: "ADULT AND CHILD MENTAL HEALTH CENTER INC(FQHCLA361)" },
    { id: 9, label: "Advocates for a Healthy Community dba Jordan Valley Community Health Center(CH07720A)" },
    { id: 10, label: "Alcona Health Center(CH051980)" },
    { id: 11, label: "Amite County Medical Services, Inc.(CH045780)" },
    { id: 12, label: "APPALACHIAN MOUNTAIN COMMUNITY HEALTH CENTERS(CHC28348-00)" },
    { id: 13, label: "ARcare(CH060940)" },
    { id: 14, label: "Arkansas Methodist Medical Center(RRC040039-00)" },
    { id: 15, label: "Athens Neighborhood Health Center(CHC24129)" },
    { id: 16, label: "Bay Clinic, Inc(CH091880)" },
    { id: 17, label: "Bibb Medical Center(DSH010058)" },
    { id: 18, label: "BIG SANDY HEALTH CARE, INC.(CH040670)" },
    { id: 20, label: "BOA VIDA HOSPITAL OF ABERDEEN, MS, LLC, D/B/A MONROE REGIONAL HOSPITAL(CAH251302-00)" },
    { id: 21, label: "BOONE MEMORIAL HOSPITAL(CAH511313-00)" },
    { id: 22, label: "Bucksport Regional Health Center(CH010340)" },
    { id: 23, label: "BUTLER COUNTY COMMUNITY HEALTH CONSORTIUM, INC. dba Primary Health Solutions(CHC08753-00)" },
    { id: 25, label: "CANYONLANDS COMMUNITY HEALTH CARE(CH091300)" },
    { id: 26, label: "CareArc, Inc.(CH074540)" },
    { id: 27, label: "Castle Family Health Centers Inc.(FQHCLA270)" },
    { id: 28, label: "CENTRAL CITY COMMUNITY HEALTH CENTER(CHC10608-00)" },
    { id: 29, label: "Central Virginia Health Services(CH030700)" },
    { id: 30, label: "Claiborne County Family Health Center(CH048420)" },
    { id: 31, label: "CLINICAS DE SALUD DEL PUEBLO,Inc.(CH090250)" },
    { id: 32, label: "Coastal Community Health Services(CHC26592-00)" },
    { id: 33, label: "Columbus Neighborhood Health dba PrimaryOne Health(CH058470)" },
    { id: 34, label: "Comanche County Hospital Authority DBA Lawton Community Health Center(CHC08779-00)" },
    { id: 35, label: "Comanche County Memorial Hospital(DSH370056)" },
    { id: 36, label: "Community Care of West Virginia- Primary Care Systems(CH034210)" },
    { id: 37, label: "COMMUNITY HEALTH CENTER OF CENTRAL WYOMING, INC.(CH086120)" },
    { id: 38, label: "COMMUNITY HEALTH CLINICS, INC. (Terry Reilly Health Services)(CH100160)" },
    { id: 39, label: "COMMUNITY HEALTH SYSTEMS, INC.(CH030790)" },
    { id: 40, label: "Community HealthCare System, Inc.(CAH171354-00)" },
    { id: 41, label: "E.A. HAWSE HEALTH CENTER, INC.(CH033130)" },
    { id: 42, label: "EAST CENTRAL OKLAHOMA FAMILY HEALTH CENTER INC(CHC10583-00)" },
    { id: 43, label: "Eastport Health Care Inc.(CHC00630)" },
    { id: 44, label: "FAMILY HEALTH CENTER INC(CH040570)" },
    { id: 45, label: "FISHER-TITUS MEDICAL CENTER(RRC360065-00)" },
    { id: 46, label: "Florida Community Health Centers(CH040370)" },
    { id: 47, label: "Free Clinic Of The New River Valley Inc(CHC26516-00)" },
    { id: 48, label: "G. A. Carmichael Family Health Center, Inc.((blank))" },
    { id: 49, label: "George County Hospital(SCH250036-00)" },
    { id: 50, label: "Grande Ronde Hospital, Inc.(CAH381321-00)" },
    { id: 51, label: "Greene County Hospital(CAH251329-00)" },
    { id: 52, label: "Grove Hill Memorial Hospital(DSH010091)" },
    { id: 53, label: "Hardin County Regional Health Center dba Lifespan Health(CH046560)" },
    { id: 54, label: "Harrison County Community Hospital(CAH261312-00)" },
    { id: 55, label: "HARRISON COUNTY HOSPITAL(CAH151331-00)" },
    { id: 56, label: "Haskell Community County Hospital dba Haskell Regional Hospital(CAH371335)" },
    { id: 57, label: "HEALTH ACCESS NETWORK(CH015110)" },
    { id: 58, label: "HealthNet, Inc.(CH053200)" },
    { id: 59, label: "HENRY COUNTY HOSPITAL(CAH361309-00)" },
    { id: 60, label: "HIGH PLAINS COMMUNITY HEALTH CENTER(CH084100)" },
    { id: 61, label: "HOCKING VALLEY COMMUNITY HOSPITAL(CAH361330-00)" },
    { id: 62, label: "HOPE FAMILY HEALTH SERVICES(CHC24109-00)" },
    { id: 63, label: "Hope Health(CHC08240-00)" },
    { id: 64, label: "Hospital Authority of Miller County DBA Miller County Hospital(CAH111305-00)" },
    { id: 65, label: "HOSPITAL DEVELOPMENT CORPORATION DBA ROANE GENERAL HOSPITAL(CAH511306-00)" },
    { id: 66, label: "HUI MALAMA OLA NA 'OIWI(NH5022)" },
    { id: 67, label: "HYNDMAN AREA HEALTH CENTER INC(CHC00532-00)" },
    { id: 68, label: "INDEPENDENT HEALTHCARE MANAGMENT, INC. D/B/A SE LACKEY MEMORIAL HOSPITAL(CAH251300-00)" },
    { id: 69, label: "KENNEDY MEMORIAL HOSPITAL-UMC(DSH310086)" },
    { id: 70, label: "KENOSHA COMMUNITY HEALTH CENTER INC(CH057260)" },
    { id: 71, label: "KLAMATH HEALTH PARTNERS INC(CH102910)" },
    { id: 72, label: "KODIAK ISLAND HEALTH CARE FOUNDATION(CH107930)" },
    { id: 73, label: "LORAIN COUNTY HEALTH & DENTISTRY(CHC12888-02)" },
    { id: 74, label: "Loudoun Community Health Center(CHC12862-00)" },
    { id: 75, label: "Lower Lights Christian Health Center Inc.(CHC12886-00)" },
    { id: 76, label: "Marshall Browning Hospital(CAH141331-00)" },
    { id: 77, label: "MEDLINK GEORGIA, INC.(CAH201303)" },
    { id: 78, label: "MILLCREEK COMMUNITY HOSPITAL(DSH390198)" },
    { id: 79, label: "Mosaic Medical(CH105600)" },
    { id: 80, label: "MOSES LAKE COMMUNITY HEALTH CENTER(CH10100A)" },
    { id: 81, label: "Mountain People's Health Councils, Inc.(CH041440)" },
    { id: 82, label: "Mountain Valleys Health Centers dba Big Valley Medical Center(CH091750)" },
    { id: 83, label: "Neighborhood Health (VA)(CH031060A)" },
    { id: 84, label: "Neighborhood Health Care Inc(CH050920)" },
    { id: 85, label: "Northeastern Health System(SCH370089-00)" },
    { id: 86, label: "NORTHEASTERN RURAL HEALTH CLINICS, INC.(CH091960)" },
    { id: 87, label: "OCOEE REGIONAL HEALTH CORPORATION(CH04123B)" },
    { id: 88, label: "OPEN DOOR HEALTH CENTER(CHC12884-00)" },
    { id: 89, label: "OPERATION SAMAHAN, INC.(CHC26623-00)" },
    { id: 90, label: "PENINSULA COMMUNITY HEALTH SERVICES OF ALASKA, INC.(CH10717A)" },
    { id: 91, label: "Penobscot Valley Hospital(CAH201303)" },
    { id: 92, label: "PERRY COUNTY MEDICAL CENTER, INC.(CH041370)" },
    { id: 93, label: "Phoenix - Diversity Health Center, Inc.(CH0452920)" },
    { id: 94, label: "Phoenix Client - Connecticut Institute for Communities(CHC16640-10)" },
    { id: 95, label: "Phoenix Client - Family Health Center of Baltimore(CH031270)" },
    { id: 96, label: "Phoenix Client - Total Health Care, Inc(CH030150)" },
    { id: 97, label: "Phoenix Client- First Choice Health Centers, Inc(CH013370)" },
    { id: 98, label: "Phoenix Client- Southwest Community Health Center(CH010810)" },
    { id: 99, label: "Phoenix -Whitney M. Young, Jr., Health Center(CH020110)" },
    { id: 100, label: "Physicians Care of Clarke(FQHCLA429)" },
    { id: 101, label: "Piedmont Access to Health Services(CH031525A)" },
    { id: 102, label: "Pinckneyville Community Hospital District(CAH141307-00)" },
    { id: 103, label: "PRESTON TAYLOR COMMUNITY HEALTH CENTER(CH030890)" },
    { id: 104, label: "Regional Medical Center Central Alabama dba Health Care Authority of the City of Greenville(SCH010150-00)" },
    { id: 105, label: "RHEA MEDICAL CENTER(CAH441310-00)" },
    { id: 106, label: "ROANE FAMILY HEALTH CARE(CH034120)" },
    { id: 107, label: "ROCKBRIDGE AREA FREE CLINIC(CHC26636-00)" },
    { id: 108, label: "ROCKING HORSE CENTER(CHC12892-00)" },
    { id: 109, label: "Rural Health Services Consortium(CH0412790)" },
    { id: 110, label: "Rural Medical Services Inc.(CH046810)" },
    { id: 111, label: "Sharkey Issaquena Community Hospital(CAH251338-00)" },
    { id: 112, label: "Shenandoah Valley Medical System, Inc(CH030900)" },
    { id: 113, label: "Skagit Valley Hospital(DSH500003)" },
    { id: 114, label: "SOUTH CENTRAL REGIONAL MEDICAL CENTER(DSH250058)" },
    { id: 115, label: "SOUTHERN DOMINION HEALTH SYSTEMS, INC.(CH034180)" },
    { id: 116, label: "ST. CHARLES HEALTH COUNCIL/STONE MOUNTAIN HEALTH SERVICES(CH030740)" },
    { id: 117, label: "STERLING HEALTH SOLUTIONS, INC.(CHC24168-00)" },
    { id: 118, label: "Summersville Regional Medical Center(CAH511322-00)" },
    { id: 119, label: "Susquehanna Community Health and Dental Clinic, Inc(CHC24159)" },
    { id: 120, label: "The Memorial Hospital d/b/a Memorial Healthcare(DSH230121)" },
    { id: 121, label: "Thomas Jefferson University(DSH390174)" },
    { id: 122, label: "Three Lower Counties Community Services(CH033010)" },
    { id: 123, label: "Tippah County Hospital(CAH251337-00)" },
    { id: 124, label: "TITUS REGIONAL MEDICAL CENTER(DSH450080)" },
    { id: 125, label: "TRIAD HEALTH SYSTEM INC(CH0452880)" },
    { id: 126, label: "Tri-Area Community Health Center(CH033230)" },
    { id: 127, label: "TUG RIVER HEALTH ASSOCIATION, INC(CH031000)" },
    { id: 128, label: "Turner House Clinic Inc.(CHC33652-00)" },
    { id: 129, label: "UNITED HEALTH CENTERS OF THE SAN JOAQUIN VALLEY(CH090560)" },
    { id: 130, label: "University of Missouri Health Care(DSH260141)" },
    { id: 131, label: "Valley Health Systems, Inc.(CH030880)" },
    { id: 132, label: "Waikiki Health(CH092060)" },
    { id: 133, label: "WEST CECIL HEALTH CENTER, INC(CH0322280)" },
    { id: 134, label: "West Park Hospital District dba Cody Regional Health(CAH531312-00)" },
    { id: 135, label: "WESTSIDE FAMILY HEALTHCARE, INC.(CH032960)" },
    { id: 136, label: "WHITE COUNTY MEDICAL CENTER(DSH040014)" },
    { id: 137, label: "Williamson Health and Wellness Center(CHC26637)" },
    { id: 138, label: "WILSON MEDICAL CENTER DBA INDEPENDENCE FAMILY MEDICINE(CAH171344)" },
    { id: 139, label: "WIRT COUNTY HEALTH SERVICE ASSOCIATION, INC(CH038800)" },

];

export const thirdPartyOptions = [
    { id: 1, label: "PharmaForce TPA" }
];

export const opaidOptions = [
    { id: 1, description: "PharmaForce Entity(PF00056)" },
    { id: 2, description: "Blue Ridge Medical Center(CH006)" },
    { id: 3, description: "Candler County Hospital(CCH-0001)" },
    { id: 4, description: "Edwards County Hospital(ED5678)" }
];
